/**
 * IMPORTS
 */

const dataTitleTableShipmentProgress = [
  { label: "Remessa", accessor: "numero_remessa" },
  { label: "Qtd", accessor: "quantidadeSolicitacao" },
  {
    label: "status",
    accessor: "status",
    isBadge: true,
    badgeClassName: "bg-green-500",
  },
  { label: "modelo", accessor: "nome_modelo", limit: 140 },
  { label: "Data Solicitação", accessor: "data" },
];

/**
 * EXPORTS
 */
export { dataTitleTableShipmentProgress };
